<template>

    <modal-container>

        <div>

            <!-- Top navbar -->
            <modal-header
                :title="'Pre-order ' + params.product.productName"
                :right="'close-dark'"
                :noIcon="true">
            </modal-header>

            <template>

                <!-- Loading animation -->
                <lottie class="loading-animation" :options="{animationData: $root.loadAnimation}" v-if="initLoad"/>

                <!-- Prompt content -->
                <prompt-div class="text-dark" v-if="!initLoad">

                    <!-- Layout body -->
                    <template v-slot:body>

                        <!-- Product image -->
                        <div class="product-image-section d-flex position-relative mt-4">
                            <div class="card-image-container d-flex justify-content-center m-auto">
                                <img class="card-image img img-fluid" :src="'/image/' + params.product.imageId" @error="$root.imageAlt" alt="">
                            </div>
                        </div>

                        <div class="pt-6">
                            <h3 class="font-lg font-weight-bolder">Would you like to set a reminder for this product?</h3>
                            <h4 class="font-md mt-5">Pick-up is not available due to closures. Would you like us to notify you when you can finish the purchase?</h4>
                        </div>
                        <button class="btn btn-md btn-inverted text-primary px-7 mt-6" @click="preorder">
                            Yes, set a reminder
                        </button>

                        <div class="bottom-bar-buffer"></div>
                        <div class="fixed-bottom full-width bg-white font-sm text-gray-dk py-4 px-10">
                            If you have already set a reminder for another item, we will replace it with this one
                        </div>

                    </template>

                </prompt-div>

            </template>

        </div>

    </modal-container>

</template>

<script>
    export default {
        props: {
            params: {
                default: null,
            },
        },

        data: function() {
            return {
                initLoad: false,
                animationData: require('../../assets/mpl-loan-terms.json'),
            }
        },

        methods: {
            preorder: function() {
                this.initLoad = true
                axios
                    .post("preorder", {
                        'product_id' : this.params.product.id,
                        'pickup_id' : this.params.pickup.id,
                    })
                    .then(response => {
                        if(response.data.product) {
                            this.$root.updateState()

                            this.$root.openModal('modal_preorder_confirmation', { name: this.params.product.productName })
                        }

                        this.initLoad = false
                    })
            }
        }
    }
</script>

<style scoped>
    .product-image-section {
        min-height: 10rem;
        max-height: 13rem;
    }
    .card-image-container {
        max-height: inherit;
        max-width: 100%;
    }
    .card-image {
        object-fit: cover;
        object-position: center;
        max-height: inherit;
        max-width: inherit;
    }
</style>